import {Component, Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {MenuXxssPage} from "../../menu-xxss/menu-xxss";

/**
 * Generated class for the MenuPartialSharePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-menu-partial-share',
    templateUrl: 'menu-partial-share.html',
})
export class MenuPartialSharePage {
    @Input() color: string;

    constructor(public navCtrl: NavController,
                public navParams: NavParams) {
    }

    openXXSS(){
        this.navCtrl.push(MenuXxssPage);
    }



}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-list/menu-partial-share/menu-partial-share.ts